// extracted by mini-css-extract-plugin
export var content = "TabList-module--content--123ee";
export var fadeInAnimation = "TabList-module--fadeInAnimation--07d7c";
export var tab = "TabList-module--tab--164ca";
export var tabsSection = "TabList-module--tabsSection--07279";
export var title = "TabList-module--title--94ced";
export var titleWrapper = "TabList-module--titleWrapper--33fb9";
export var wrapper = "TabList-module--wrapper--1a721";